var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BInputGroup,[_c(_setup.BFormInput,{attrs:{"value":_setup.date,"type":"date"},on:{"input":_setup.updateDate}}),_vm._v(" "),_c(_setup.BFormInput,{attrs:{"value":_setup.time,"type":"time"},on:{"input":_setup.updateTime}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }